import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m22.427 5.573-4.278 8.983-.015.032-3.207 6.735a.75.75 0 1 1-1.354-.646L16.276 15H3.75a.75.75 0 0 1-.531-1.28l3.97-3.97-3.97-3.97a.75.75 0 0 1 .53-1.28h18a.75.75 0 0 1 .678 1.072"
    }, null, -1)
  ]))]))
}
export default { render: render }